import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import SetupPage from '../components/setup/SetupPage';

const SetupRoute: React.FC = () => {
  return <SetupPage />;
};

export const Route = createFileRoute('/setup')({
  component: SetupRoute,
});
